export default __webpack_public_path__ + "static/assets/a17dabf705be43727883843a177d4351.jpg";